import useElapsedTimeFromNow from 'app/features/conversations/Hooks/useElapsedTimeFromNow';
import Spinner from 'Components/Spinner';

export default function ElapsedTimer({ date }: { date: string }) {
  const [elapsed, unit] = useElapsedTimeFromNow(date);

  if (elapsed === undefined || unit === undefined) return <>Now</>;

  return (
    <>{`${elapsed > 0 ? elapsed : ''} ${unit}${elapsed > 1 ? 's' : ''}`}</>
  );
}
